// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"c7797528","88":"54732e9b","110":"92048b8d","346":"ca9e22c4","547":"3bd27501","625":"7f256aee","637":"7ea0ccca","651":"fe8f90e6","673":"612ea8c6","674":"728577f8","679":"d74ae034","700":"c9f14764","821":"32232e5c"}[chunkId] + ".chunk.js";
};